import * as React from 'react';
import { registerPasteUnfurlingPlugin, type PasteUnfurlingPluginBaseProps } from '@fluentui-copilot/chat-input-plugins';
import { $createChatInputEntityNode, type ChatInputEntityProps } from '../../ChatInputEntity';
import { useLexicalComposerContext } from '@fluentui-copilot/react-text-editor';

export type PasteUnfurlingPluginProps<ExtraDataType> = Omit<
  PasteUnfurlingPluginBaseProps<ExtraDataType, ChatInputEntityProps>,
  '$createEntityNode'
> &
  Pick<Partial<PasteUnfurlingPluginBaseProps<ExtraDataType, ChatInputEntityProps>>, '$createEntityNode'>;

export const PasteUnfurlingPlugin = <ExtraDataType>(props: PasteUnfurlingPluginProps<ExtraDataType>): null => {
  const { $createEntityNode = $createChatInputEntityNode, ...rest } = props;

  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    return registerPasteUnfurlingPlugin(editor, { ...rest, $createEntityNode });
  }, [$createEntityNode, editor, rest]);

  return null;
};
